import React from "react";
import {Invoice} from "models/Invoice";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

const InvoiceStateBadge = ({invoice}: {invoice: Invoice}) => {
    const {t} = useOfficeTranslation();
    const paid = !invoice.draft && !invoice.quote && invoice.IsPaid();
    const label = invoice.quote ? t("common.quote") : invoice.draft ? t("common.draft")
        : paid ? t("common.paid") : t("invoice.invoiceStatusCard.notPaid");
    return <span className={`invoice-state-badge ${paid ? "invoice-state-badge--paid" : "invoice-state-badge--pending"}`}>
        <i className={`mdi ${paid ? "mdi-check-all" : "mdi-clock-outline"}`} aria-hidden="true" /> {label}
    </span>;
};
export default InvoiceStateBadge;
